/** Digisaka auth brand — matches digisaka app `tailwind.config.js` + Login.vue. */
export const AUTH_GREEN = '#008540';
export const AUTH_GREEN_HOVER = '#097a34';
export const AUTH_GREEN_LIGHT = '#00854014';
export const AUTH_GREEN_BORDER = '#00854080';
export const AUTH_GREEN_SOFT = '#00854020';

export const AUTH_GREEN_950 = '#0B3A22';
export const AUTH_GREEN_900 = '#0F5A2E';
export const AUTH_GREEN_600 = '#2F8F52';
export const AUTH_SAGE = '#A9CBB2';
export const AUTH_SAGE_600 = '#6b7280';
/** Page background — digisaka app login `bg-[#f8faf7]`. */
export const AUTH_PAPER = '#f8faf7';
/** Input / card surface — `bg-white` on login inputs. */
export const AUTH_SURFACE = '#FFFFFF';
export const AUTH_GOLD = '#34d399';
/** Headings — Tailwind `gray-900`. */
export const AUTH_INK = '#111827';
/** Body / helper — Tailwind `gray-500`. */
export const AUTH_MUTED = '#6B7280';
/** Form labels — Tailwind `gray-700`. */
export const AUTH_LABEL = '#374151';
/** Placeholder — Tailwind `gray-400`. */
export const AUTH_PLACEHOLDER = '#9CA3AF';
/** Borders — Tailwind `gray-200`. */
export const AUTH_LINE = '#E5E7EB';
export const AUTH_CTA_HOVER = '#097a34';
export const AUTH_SCRIM = 'rgba(9,33,20,0.62)';

export const AUTH_BRAND_PANEL_BG =
  'radial-gradient(120% 90% at 85% -10%, #2F8F52 0%, transparent 55%), linear-gradient(165deg, #0F5A2E 0%, #0B3A22 100%)';

/** Matches digisaka app `html { font-family: "Poppins", sans-serif }`. */
export const AUTH_FONT_SANS = "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
export const AUTH_FONT_SERIF = "'Poppins', sans-serif";
export const AUTH_FONT_MONO = "'Poppins', sans-serif";
